import { useState } from 'react';
import Hero from './components/Hero';
import Features from './components/Features';
import Security from './components/Security';
import HowItWorks from './components/HowItWorks';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Features />
      <Security />
      <HowItWorks />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}
